import React from 'react';
import { matchSorter } from 'match-sorter';

export function BillingCompanyColumns() {
  const columns = [
    {
      id: 'id',
      Header: 'Ordre',
      accessor: 'id',
      minWidth: 60,
      maxWidth: 60,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['id'] }),
      filterAll: true,
    },
    {
      Header: 'Sender Ref',
      id: 'orderReference',
      accessor: 'orderReference',
      minWidth: 60,
      maxWidth: 120,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['orderReference'] }),
      filterAll: true,
    },
    {
      Header: 'Date created',
      id: 'createdDate',
      accessor: 'createdDate',
      minWidth: 35,
      maxWidth: 100,
    },
    {
      Header: 'Date delivered',
      id: 'deliverFrom',
      accessor: 'deliverFrom',
      minWidth: 35,
      maxWidth: 100,
    },
    {
      Header: 'Status',
      accessor: 'statusLabel',
      minWidth: 40,
      maxWidth: 80,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['statusLabel'] }),
      filterAll: true,
    },
    {
      Header: 'Sender Name',
      id: 'senderName',
      accessor: 'senderName',
      minWidth: 40,
      maxWidth: 100,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['senderName'] }),
      filterAll: true,
    },
    {
      Header: 'Sender email',
      id: 'senderEmail',
      accessor: 'senderEmail',
      minWidth: 100,
      maxWidth: 130,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['senderEmail'] }),
      filterAll: true,
    },
    {
      Header: 'Sender address',
      id: 'pickupAddress',
      accessor: 'pickupAddress',
      minWidth: 80,
      maxWidth: 260,
    },
    {
      Header: 'Kolli',
      accessor: 'packagesNumber',
      minWidth: 35,
      maxWidth: 45,
    },
    {
      Header: 'Price',
      id: 'price.fractionalDenomination',
      accessor: 'price.fractionalDenomination',
      minWidth: 80,
      maxWidth: 260,
    },
    {
      Header: 'size',
      id: 'packageSize',
      accessor: 'packageSize',
      minWidth: 65,
      maxWidth: 80,
    },
    {
      Header: 'Product',
      accessor: 'product',
      minWidth: 65,
      maxWidth: 80,
    },
    {
      Header: 'Oversized parcels',
      id: 'oversizedParcels',
      accessor: 'numberOfOverSizedParcels',
      minWidth: 65,
      maxWidth: 80,
    },
    {
      Header: 'Leveringstype',
      accessor: 'size',
      minWidth: 35,
      maxWidth: 120,
    },
    {
      Header: 'left at doorstep',
      id: 'leftAtDoorstep',
      accessor: 'performedVerifications.confirmationPhoto',
      minWidth: 35,
      maxWidth: 120,
      Cell: ({ value }) => {
        if (value === true) {
          return 'Left at doorstep';
        } else if (value === false) {
          return 'Home delivery';
        }
        return 'no value';
      },
      filterMethod: (filter, row) => {
        if (filter.value === 'all') {
          return true;
        }
        if (filter.value === 'true') {
          return row[filter.id] === true;
        }
        return row[filter.id] === false;
      },
      Filter: function filterDoorstep({ filter, onChange }) {
        return (
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'all'}
          >
            <option value="all">Show All</option>
            <option value="true">Left at doorstep</option>
            <option value="false">Home delivery</option>
          </select>
        );
      },
    },
    {
      Header: 'failed delivery count',
      id: 'failedDeliveryCount',
      accessor: 'failedDeliveryCount',
      minWidth: 80,
      maxWidth: 150,
    },
    {
      Header: 'zone',
      id: 'zone',
      accessor: 'zone',
      minWidth: 80,
      maxWidth: 120,
    },
    {
      Header: 'Mottaker',
      id: 'recipientName',
      accessor: 'recipientName',
      minWidth: 80,
      maxWidth: 120,
    },
    {
      Header: 'Recipient Address',
      id: 'recipientAddress',
      accessor: 'recipientAddress',
      minWidth: 80,
      maxWidth: 260,
    },
    {
      Header: 'Recipient Email',
      id: 'recipientEmail',
      accessor: 'recipientEmail',
      minWidth: 40,
      maxWidth: 100,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['recipientEmail'] }),
      filterAll: true,
    },
    {
      Header: 'Recipient Phone',
      id: 'recipientPhoneNumber',
      accessor: 'recipientPhoneNumber',
      minWidth: 40,
      maxWidth: 100,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { keys: ['recipientPhoneNumber'] }),
      filterAll: true,
    },
  ];

  return columns;
}
